import React from 'react';

import Info from './info/Info';
import Investors from './investors/Investors';
import { Team } from './team/Team';
import Career from './Career';
import Header from './Header';
import More from './More';

const AboutPage = () => (
    <>
      <Header />
      <Info />
      <Team />
      <Career />
      <Investors />
      <More />
    </>
);

export default AboutPage;
